class VaillantCollectionInfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.grid = document.getElementById(this.dataset.gridId);
    this.link = this.querySelector('[data-infinite-scroll-link]');
    this.loadingIndicator = this.querySelector('[data-infinite-scroll-loading]');
    this.loading = false;

    if (!this.grid || !this.link || !this.dataset.nextUrl || !('IntersectionObserver' in window)) return;

    this.classList.add('is-enhanced');
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
    }, { rootMargin: '600px 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async loadNextPage() {
    if (this.loading || !this.dataset.nextUrl) return;

    this.loading = true;
    this.setAttribute('aria-busy', 'true');
    this.loadingIndicator.hidden = false;

    try {
      const response = await fetch(this.dataset.nextUrl, {
        headers: { Accept: 'text/html' },
      });

      if (!response.ok) throw new Error(`Unable to load collection page: ${response.status}`);

      const documentFromResponse = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = documentFromResponse.getElementById(this.dataset.gridId);
      const nextLoader = documentFromResponse.querySelector('collection-infinite-scroll-vaillant');

      if (!nextGrid) throw new Error('The next collection product grid was not found.');

      const newItems = [...nextGrid.children].filter(
        (item) =>
          item.classList.contains('grid__item') &&
          !item.classList.contains('vaillant-collection__editorial')
      );
      newItems.forEach((item) => item.classList.add('scroll-trigger--cancel'));
      this.grid.append(...newItems);

      if (nextLoader?.dataset.nextUrl) {
        this.dataset.nextUrl = nextLoader.dataset.nextUrl;
        this.link.href = nextLoader.dataset.nextUrl;
        this.loading = false;
        this.removeAttribute('aria-busy');
        this.loadingIndicator.hidden = true;
      } else {
        this.finish();
      }
    } catch (error) {
      console.error(error);
      this.classList.remove('is-enhanced');
      this.observer?.disconnect();
      this.loading = false;
      this.removeAttribute('aria-busy');
      this.loadingIndicator.hidden = true;
    }
  }

  finish() {
    this.observer?.disconnect();
    this.dataset.nextUrl = '';
    this.removeAttribute('aria-busy');
    this.remove();
  }
}

if (!customElements.get('collection-infinite-scroll-vaillant')) {
  customElements.define('collection-infinite-scroll-vaillant', VaillantCollectionInfiniteScroll);
}
